"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDeleteAction = exports.useDeleteCollectionDialog = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function useDeleteCollectionDialog(getUrl) {
    const callApi = (0, event_callback_hook_1.useEventCallback)((id, collectionId) => {
        return (0, abortable_fetch_1.abortableFetch)(`${getUrl(id, collectionId)}`, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        });
    });
    return {
        callApi,
    };
}
exports.useDeleteCollectionDialog = useDeleteCollectionDialog;
function resolveDeleteAction(props) {
    return {
        hide: false,
        useApi: useDeleteCollectionDialog,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__DELETE_LABEL", defaultMessage: "Smazat" })),
        title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__DELETE_TITLE", defaultMessage: "Pozor" })),
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__DELETE_TEXT", defaultMessage: "Opravdu chcete smazat polo\u017Eku?" })),
        ...props,
    };
}
exports.resolveDeleteAction = resolveDeleteAction;
//# sourceMappingURL=delete-collection-hook.js.map